import React from "react";

import { Card } from "src/base-components/Card";
import { SplitNodeV2 } from "src/constants/NodeDataTypes";
import { Input } from "src/design-system/Input";
import { useIsFieldHighlighted } from "src/flowGraph/canvasSearch/CanvasSearchHighlightContext";
import { useGraphStore } from "src/store/StoreProvider";
import { useHighlightedScrollIntoView } from "src/utils/useHighlightedScrollIntoview";

type Props = {
  selectedNode: SplitNodeV2;
  immutable: boolean;
};

export const DefaultBranchCard: React.FC<Props> = ({
  selectedNode,
  immutable,
}) => {
  const { getNodeToIncomingEdge, updateNode } = useGraphStore();

  const isDefaultBranchHighlighted = useIsFieldHighlighted(
    selectedNode.data.default_edge_id,
  );
  const [highlightRef] = useHighlightedScrollIntoView(
    isDefaultBranchHighlighted,
  );

  const defaultBranchName = getNodeToIncomingEdge(
    selectedNode.data.default_edge_id,
  )?.data.label;

  const onDefaultBranchNameChange: React.FormEventHandler<HTMLInputElement> = (
    e,
  ) => {
    const branchNodeToRename = getNodeToIncomingEdge(
      selectedNode.data.default_edge_id,
    );
    if (branchNodeToRename) {
      updateNode({
        newName: e.currentTarget.value,
        nodeId: branchNodeToRename.id,
      });
    }
  };

  return (
    <Card className="mt-5 space-y-3">
      <Card.Header>
        <Card.Title title="Default branch" />
      </Card.Header>
      <Card.Content>
        <div className="flex flex-row items-center border-gray-200 border-t pt-3">
          <div className="mr-2 w-24 font-inter-medium-12px text-gray-700">
            Use branch
          </div>
          <div ref={highlightRef} className="flex-grow">
            <Input
              defaultValue={defaultBranchName}
              disabled={immutable}
              highlighted={isDefaultBranchHighlighted}
              variant="monospaced"
              onChange={onDefaultBranchNameChange}
            />
          </div>
        </div>
      </Card.Content>
    </Card>
  );
};
